import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import { ProtectedRoute } from "./components/ProtectedRoute";

import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import PendingApproval from "./pages/PendingApproval";
import Privacy from "./pages/Privacy";
import Cookie from "./pages/Cookie";
import AdminDashboard from "./pages/admin/AdminDashboard";
import MedicoDashboard from "./pages/medico/MedicoDashboard";
import IsfDashboard from "./pages/isf/IsfDashboard";

const ADMIN_ROLES = ["admin"];
const MEDICO_ROLES = ["medico"];
const ISF_ROLES = ["isf"];

function App() {
  return (
    <div className="App">
      <Toaster position="top-right" richColors />
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/registrati" element={<Register />} />
            <Route path="/password-dimenticata" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/cookie" element={<Cookie />} />
            <Route
              path="/in-attesa"
              element={
                <ProtectedRoute requireApproved={false}>
                  <PendingApproval />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin"
              element={
                <ProtectedRoute roles={ADMIN_ROLES}>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/medico"
              element={
                <ProtectedRoute roles={MEDICO_ROLES}>
                  <MedicoDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/isf"
              element={
                <ProtectedRoute roles={ISF_ROLES}>
                  <IsfDashboard />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
